const initialState = {
  show: null,
  fetching: false,
  fetched: false,
  error: null,
  loading: false,
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'CONVERSATION_FETCH_PENDING': {
      return {
        ...state,
        fetching: true,
        show: null,
      }
    }

    case 'CONVERSATION_FETCH_SILENT_REJECTED':
    case 'CONVERSATION_FETCH_REJECTED': {
      return {
        ...state,
        fetching: false,
        error: true,
      }
    }

    case 'CONVERSATION_FETCH_FAILURE': {
      return {
        ...state,
        fetching: false,
        error: true,
      }
    }

    case 'CONVERSATION_FETCH_SILENT_FULFILLED':
    case 'CONVERSATION_FETCH_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        show: action.payload.data,
      }
    }

    default: {
      return state
    }
  }
}
